import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Alert, Box, CircularProgress, Stack, Typography } from "@mui/material";
import { resolveChampionVideoShareLink } from "services/fde/championVideoRolloutService";

const VIDEO_LABELS = {
  ceo: "CEO",
  board: "Board",
  cmo: "CMO",
  cno: "CNO",
  cfo: "CFO",
  compliance: "Compliance",
};

const ChampionVideoRolloutPage = () => {
  const { linkCode } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [payload, setPayload] = useState(null);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      if (!linkCode) {
        setError("This share link is invalid.");
        setLoading(false);
        return;
      }
      setLoading(true);
      setError("");
      try {
        const data = await resolveChampionVideoShareLink(linkCode);
        if (!cancelled) setPayload(data);
      } catch (err) {
        if (!cancelled) {
          setError(
            err?.message || err?.details || "This share link could not be opened.",
          );
          setPayload(null);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => {
      cancelled = true;
    };
  }, [linkCode]);

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 10 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error || !payload?.outputUrl) {
    return (
      <Box sx={{ maxWidth: 560, mx: "auto", p: 3 }}>
        <Alert severity="error">{error || "Video unavailable."}</Alert>
      </Box>
    );
  }

  const label = VIDEO_LABELS[payload.videoId] || payload.videoId || "Rollout video";

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "background.default",
        px: 2,
        py: 4,
      }}
    >
      <Stack spacing={2} sx={{ maxWidth: 960, mx: "auto" }}>
        <Typography variant="h5" component="h1">
          {label} rollout video
        </Typography>
        <Box
          component="video"
          src={payload.outputUrl}
          controls
          playsInline
          sx={{
            width: "100%",
            maxHeight: "80vh",
            bgcolor: "common.black",
            borderRadius: 1,
          }}
        />
      </Stack>
    </Box>
  );
};

export default ChampionVideoRolloutPage;
